module.exports = __webpack_public_path__ + "media/img/feature1-e0e9172a2318e56ee5eff6e2299b6b88.svg";